const rankingItems = [
  { rank: 1, title: '孤胆狙击', type: '动作', heat: '9.8', tag: '热播中' },
  { rank: 2, title: '长安十二夜', type: '悬疑', heat: '9.6', tag: '新上线' },
  { rank: 3, title: '逆流而上', type: '剧情', heat: '9.5', tag: '飙升' },
  { rank: 4, title: '机甲风暴2046', type: '科幻', heat: '9.3', tag: '推荐' },
  { rank: 5, title: '山海传说', type: '奇幻', heat: '9.1', tag: '热播' },
  { rank: 6, title: '极速追逐', type: '动作', heat: '8.9', tag: '新片' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热播排行榜
          </h2>
          <p className="text-foreground-500 text-sm">实时更新，大家都在看的91电影免费大片</p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 py-4 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-100 transition-colors cursor-pointer`}
            >
              <span
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold whitespace-nowrap ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-heading text-foreground-950 truncate">{item.title}</h3>
                <p className="text-foreground-600 text-xs">{item.type}</p>
              </div>
              <span className="px-2.5 py-1 rounded-full bg-accent-500/10 text-accent-300 text-xs whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-primary-500 font-heading text-lg whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}